import { projectAncestorIds, type TreeProject } from '../lib/projectTree'

const PROJECT_PATH = /^\/home\/([^/]+)\/project\/([^/?#]+)/

/** Lebensbereich und Projekt einer Tab-Adresse (`/home/<bereich>/project/<id>`), sonst `null`. */
export function projectOfPath(path: string | undefined): { lifeSpace: string; projectId: string } | null {
  const match = path?.match(PROJECT_PATH)
  return match ? { lifeSpace: match[1], projectId: match[2] } : null
}

/**
 * **Die Elternprojekte in der Breadcrumb** (#185): die Stufen zwischen Gruppe und Titel,
 * von oben nach unten — Persönlich › Projekte › **Haus › Garten** › Beete. Ohne das Projekt
 * selbst; dessen Name kommt wie bisher, wenn sein Titel aus dem Bild scrollt.
 *
 * Aus der Tab-Adresse, wie die Gruppe (`getSectionTitle`), nicht aus der Projektseite: Die lädt
 * beim Wechsel ihr Projekt neu, und die Stufen wären dazwischen kurz leer — eine Stufe, die
 * bleibt, blendete aus und gleich wieder ein.
 */
export function breadcrumbTrail(
  path: string | undefined,
  projects: readonly (TreeProject & { name: string })[],
  unnamed: string,
): string[] {
  const active = projectOfPath(path)
  if (!active) return []
  const names = new Map(projects.map(p => [p.id, p.name || unnamed]))
  return projectAncestorIds(projects, active.projectId).reverse().map(id => names.get(id) ?? unnamed)
}
